/**
 * Configuración de Roles y Permisos - Frontend RxApp
 * Debe coincidir con server/config/roles.js
 */

export const MODULES = {
  DASHBOARD: 'dashboard',
  CLIENTES: 'clientes',
  SERVICIOS: 'servicios',
  VENTAS: 'ventas',
  FACTURAS: 'facturas',
  PROYECTOS: 'proyectos',
  USUARIOS: 'usuarios',
  CONFIGURACION: 'configuracion',
  PROPUESTAS: 'propuestas',
  AI_CHAT: 'ai-chat',
  CHAT_SESSIONS: 'chat-sessions'
};

export const ROLES = {
  SUPER_ADMIN: 'super-admin',
  GERENTE: 'gerente',
  DIRECTOR_DESARROLLO: 'director-desarrollo',
  DIRECTOR_COMERCIAL: 'director-comercial',
  DIRECTOR_FINANCIERO: 'director-financiero',
  ASESOR_DESARROLLO: 'asesor-desarrollo',
  ASESOR_COMERCIAL: 'asesor-comercial',
  ASESOR_FINANCIERO: 'asesor-financiero'
};

export const ROLE_LABELS = {
  [ROLES.SUPER_ADMIN]: 'Super Administrador',
  [ROLES.GERENTE]: 'Gerente',
  [ROLES.DIRECTOR_DESARROLLO]: 'Director de Desarrollo',
  [ROLES.DIRECTOR_COMERCIAL]: 'Director Comercial',
  [ROLES.DIRECTOR_FINANCIERO]: 'Director Financiero',
  [ROLES.ASESOR_DESARROLLO]: 'Asesor de Desarrollo',
  [ROLES.ASESOR_COMERCIAL]: 'Asesor Comercial',
  [ROLES.ASESOR_FINANCIERO]: 'Asesor Financiero'
};

// Módulos accesibles por rol (para menú de navegación)
const MODULES_BY_ROLE = {
  [ROLES.SUPER_ADMIN]: [MODULES.DASHBOARD, MODULES.CLIENTES, MODULES.SERVICIOS, MODULES.VENTAS, MODULES.FACTURAS, MODULES.PROYECTOS, MODULES.USUARIOS, MODULES.CONFIGURACION, MODULES.PROPUESTAS, MODULES.CHAT_SESSIONS, MODULES.AI_CHAT],
  [ROLES.GERENTE]: [MODULES.DASHBOARD, MODULES.CLIENTES, MODULES.SERVICIOS, MODULES.VENTAS, MODULES.FACTURAS, MODULES.PROYECTOS, MODULES.USUARIOS, MODULES.PROPUESTAS, MODULES.CHAT_SESSIONS, MODULES.AI_CHAT],
  [ROLES.DIRECTOR_DESARROLLO]: [MODULES.DASHBOARD, MODULES.CLIENTES, MODULES.SERVICIOS, MODULES.PROYECTOS, MODULES.CHAT_SESSIONS, MODULES.AI_CHAT],
  [ROLES.DIRECTOR_COMERCIAL]: [MODULES.DASHBOARD, MODULES.CLIENTES, MODULES.SERVICIOS, MODULES.VENTAS, MODULES.PROPUESTAS, MODULES.CHAT_SESSIONS, MODULES.AI_CHAT],
  [ROLES.DIRECTOR_FINANCIERO]: [MODULES.DASHBOARD, MODULES.CLIENTES, MODULES.SERVICIOS, MODULES.VENTAS, MODULES.FACTURAS, MODULES.AI_CHAT],
  [ROLES.ASESOR_DESARROLLO]: [MODULES.DASHBOARD, MODULES.PROYECTOS, MODULES.AI_CHAT],
  [ROLES.ASESOR_COMERCIAL]: [MODULES.DASHBOARD, MODULES.CLIENTES, MODULES.SERVICIOS, MODULES.VENTAS, MODULES.PROPUESTAS, MODULES.CHAT_SESSIONS, MODULES.AI_CHAT],
  [ROLES.ASESOR_FINANCIERO]: [MODULES.DASHBOARD, MODULES.CLIENTES, MODULES.SERVICIOS, MODULES.VENTAS, MODULES.FACTURAS, MODULES.AI_CHAT]
};

export function canAccessModule(role, module) {
  const modules = MODULES_BY_ROLE[role];
  return modules && modules.includes(module);
}

export function getRoleLabel(role) {
  return ROLE_LABELS[role] || role;
}
